import { render, staticRenderFns } from "./RelatorioVidasPJ.vue?vue&type=template&id=69d452a8&"
import script from "./RelatorioVidasPJ.vue?vue&type=script&lang=js&"
export * from "./RelatorioVidasPJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports